<template>
  <div>
    <div class="content" style="width: auto">
      <div class="cont-list">
        <span class="list"
          >{{ this.parentRoute.menuName }}-{{ title }}药品基础信息维护</span
        >
      </div>
      <div class="cont-main">
        <el-form
          label-position="top"
          label-width="80px"
          ref="form"
          :model="form"
          :rules="rules"
        >
          <el-row class="show-header" :gutter="30">
            <el-col :span="4">
              <el-form-item label="药品名称" prop="basicInfo.name">
                <el-input
                  maxlength="50"
                  placeholder="请输入"
                  v-model="form.basicInfo.name"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="药品规格" prop="basicInfo.specifications">
                <el-input
                  maxlength="50"
                  placeholder="请输入"
                  v-model="form.basicInfo.specifications"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="药品剂型" prop="basicInfo.dosageForm">
                <el-select
                  v-model="form.basicInfo.dosageForm"
                  value-key="id"
                  style="width: 100%"
                  filterable
                  :filter-method="(val) =>filterMethod(val,'dosageForm')"
                  @clear="clear('dosageForm')"
                >
                  <el-option
                    v-for="item in dosageFormOption"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="库存单位" prop="basicInfo.inventoryUnit">
                <el-input
                  maxlength="50"
                  placeholder="请输入"
                  :disabled="
                    this.formMode == 2 && form.checkUsedState
                      ? true
                      : false
                  "
                  v-model="form.basicInfo.inventoryUnit"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="最小单位" prop="basicInfo.smallestUnit">
                <el-input
                  maxlength="50"
                  placeholder="请输入"
                  :disabled="
                    this.formMode == 2 && form.checkUsedState
                      ? true
                      : false
                  "
                  v-model="form.basicInfo.smallestUnit"
                  style="width: 100%"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item
                label="库存单位换算系数"
                prop="basicInfo.inveUnitConverFactor"
              >
                <div style="display: flex">
                  <span v-if="form.basicInfo.inventoryUnit"
                    >1{{ form.basicInfo.inventoryUnit }}=</span
                  >
                  &nbsp;<el-input
                    maxlength="50"
                    placeholder="请输入"
                    :disabled="
                      this.formMode == 2 && form.checkUsedState
                        ? true
                        : false
                    "
                    v-model="form.basicInfo.inveUnitConverFactor"
                    style="flex: 1"
                  ></el-input
                  >&nbsp;{{ form.basicInfo.smallestUnit }}
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-tabs
            type="card"
            v-model="activeName"
            class="demo-tabs"
          >
            <el-tab-pane label="基础信息" name="basicInfo">
              <el-row :gutter="30">
                <el-col :span="4">
                  <el-form-item label="药品编码" prop="basicInfo.no">
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      disabled
                      v-model="form.basicInfo.no"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="通用名" prop="basicInfo.commonName">
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      v-model="form.basicInfo.commonName"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="拼音码" prop="basicInfo.pinyinCode">
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      disabled
                      v-model="form.basicInfo.pinyinCode"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="剂量单位" prop="basicInfo.doseUnit">
                    <el-select
                      v-model="form.basicInfo.doseUnit"
                      value-key="id"
                      style="width: 100%"
                      filterable
                      :filter-method="(val) =>filterMethod(val,'doseUnit')"
                      @clear="clear('doseUnit')"
                    >
                      <el-option
                        v-for="item in doseUnitOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="基本剂量" prop="basicInfo.basicdDose">
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      v-model="form.basicInfo.basicdDose"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="药品类型" prop="basicInfo.drugType">
                    <el-select
                      v-model="form.basicInfo.drugType"
                      value-key="id"
                      filterable
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in drugTypeOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="药品分类"
                    prop="basicInfo.classificationName"
                  >
                    <SelectTree
                      @handleCheckChange="ProductCategoryChange"
                      :filterable="true"
                      clearable
                      :filterMethod="getProductCategory"
                      :defaultProps="defaultProps"
                      :placeholder="'请选择药品分类'"
                      :data="classificationNameOption"
                      :defaultValue="form.basicInfo.classificationName"
                      style="width: 100%"
                    >
                    </SelectTree>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="财务分类"
                    prop="basicInfo.financialClassName"
                  >
                     <SelectTree  @handleCheckChange="financeTypeChange" :filterable="true" clearable :filterMethod="getFinanceTypes" :defaultProps="defaultProps" :placeholder="'请选择财务分类'" :data="STATIC_FinanceTypes" :defaultValue="form.basicInfo.financialClassName"></SelectTree>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="产地" prop="basicInfo.factoryInfoName">
                    <el-cascader
                      style="width: 100%"
                      v-model="form.basicInfo.factoryInfoName"
                      :props="cascaderProps"
                      :key="cascaderKey" 
                      clearable
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="包装材质"
                    prop="basicInfo.packagingMaterial"
                  >
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      v-model="form.basicInfo.packagingMaterial"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="有效期（月）"
                    prop="basicInfo.termOfValidityByMon"
                  >
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      v-model="form.basicInfo.termOfValidityByMon"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="条码管理"
                    prop="basicInfo.barcodeManagement"
                  >
                    <el-select
                      v-model="form.basicInfo.barcodeManagement"
                      value-key="id"
                      style="width: 100%"
                      @change="handleBarcodeManagement"
                    >
                      <el-option
                        v-for="item in barcodeManagementOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="储存方式" prop="basicInfo.storageMethod">
                    <el-select
                      v-model="form.basicInfo.storageMethod"
                      value-key="id"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in storageMethodOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                 <el-col :span="4">
                  <el-form-item
                    label="是否处方药品"
                    prop="basicInfo.isPrescription"
                  >
                    <el-radio-group v-model="form.basicInfo.isPrescription" :disabled="disabledIsControlIsPrescriptio">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="是否高警示药品"
                    prop="basicInfo.isHighWarning"
                  >
                    <el-radio-group v-model="form.basicInfo.isHighWarning">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="是否贵重药品"
                    prop="basicInfo.isValuable"
                  >
                    <el-radio-group v-model="form.basicInfo.isValuable">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="是否川产" prop="basicInfo.isInSC">
                    <el-radio-group v-model="form.basicInfo.isInSC">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="是否管控药品" prop="basicInfo.isControl">
                    <el-radio-group v-model="form.basicInfo.isControl" :disabled="disabledIsControlIsPrescriptio">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="30">
                <el-col :span="4">
                  <el-form-item
                    label="是否需要试敏"
                    prop="basicInfo.isNeedSensitivity"
                  >
                    <el-radio-group v-model="form.basicInfo.isNeedSensitivity">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="是否新药" prop="basicInfo.isNewDrug">
                    <el-radio-group v-model="form.basicInfo.isNewDrug">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="是否基药"
                    prop="basicInfo.isBasicMedicine"
                  >
                    <el-radio-group v-model="form.basicInfo.isBasicMedicine">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="药品说明书"
                    prop="basicInfo.instructions"
                  >
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      v-model="form.basicInfo.instructions"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                    label="药品附件图片"
                    prop="basicInfo.accessoriesImg"
                  >
                    <MyUpload
                      :canEdit="false"
                      @filesChange="filesChange"
                      :isLimitMaxSiz="true"
                      :oldList="form.basicInfo.accessoriesImgData || []"
                      :defaultMaxSize="10"
                    ></MyUpload>
                    <p>
                      只能上传png/jpg/jpeg/pdf格式文件且为文件白名单支持的格式，且大小不超过10Mb
                    </p>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="药品性质" name="drugNature">
              <el-row :gutter="30">
                <el-col :span="4">
                  <el-form-item
                    label="是否抗菌药品"
                    prop="nature.isAntibacterialDrug"
                  >
                    <el-radio-group v-model="form.nature.isAntibacterialDrug">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="form.nature.isAntibacterialDrug">
                  <el-form-item
                    label="抗菌级别"
                    prop="nature.antibacterialLevel"
                  >
                    <el-select
                      v-model="form.nature.antibacterialLevel"
                      value-key="id"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in antibacterialLevelOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="是否抗生素药品"
                    prop="nature.isAntibioticDrug"
                  >
                    <el-radio-group v-model="form.nature.isAntibioticDrug">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="form.nature.isAntibioticDrug">
                  <el-form-item
                    label="抗生素级别"
                    prop="nature.antibioticLevel"
                  >
                    <el-select
                      v-model="form.nature.antibioticLevel"
                      value-key="id"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in antibioticLevelOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="是否精神类药品"
                    prop="nature.isPsychotropicDrug"
                  >
                    <el-radio-group v-model="form.nature.isPsychotropicDrug" @change="changeRadio">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="form.nature.isPsychotropicDrug">
                  <el-form-item label="精神类级别" prop="nature.spiritualLevel">
                    <el-select
                      v-model="form.nature.spiritualLevel"
                      value-key="id"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in spiritualLevelOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="是否放射性药品"
                    prop="nature.isRadioactiveDrug"
                  >
                    <el-radio-group v-model="form.nature.isRadioactiveDrug" @change="changeRadio">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="form.nature.isRadioactiveDrug">
                  <el-form-item
                    label="放射性级别"
                    prop="nature.radioactiveLevel"
                  >
                    <el-select
                      v-model="form.nature.radioactiveLevel"
                      value-key="id"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in radioactiveLevelOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                  <el-col :span="4">
                  <el-form-item
                    label="是否麻醉药品"
                    prop="nature.isAnestheticDrug"
                  >
                    <el-radio-group v-model="form.nature.isAnestheticDrug" @change="changeRadio">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="是否毒性药品" prop="nature.isToxicDrug">
                    <el-radio-group v-model="form.nature.isToxicDrug" @change="changeRadio">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="是否激素药品"
                    prop="nature.isHormoneMedication"
                  >
                    <el-radio-group v-model="form.nature.isHormoneMedication">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="是否大输液药品"
                    prop="nature.isLargeInfusionDrugs"
                  >
                    <el-radio-group v-model="form.nature.isLargeInfusionDrugs">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="是否消化药品"
                    prop="nature.isDigestiveDrugs"
                  >
                    <el-radio-group v-model="form.nature.isDigestiveDrugs">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="是否抗肿瘤药品"
                    prop="nature.isAntitumorDrugs"
                  >
                    <el-radio-group v-model="form.nature.isAntitumorDrugs">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="是否心脑血管药品"
                    prop="nature.isCVDrugs"
                  >
                    <el-radio-group v-model="form.nature.isCVDrugs">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="是否防疫药品" prop="nature.isEpDrugs">
                    <el-radio-group v-model="form.nature.isEpDrugs">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                 <el-col :span="4">
                  <el-form-item
                    label="是否营养药品"
                    prop="nature.isNutritionalDrugs"
                  >
                    <el-radio-group v-model="form.nature.isNutritionalDrugs">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="是否制剂" prop="nature.isPreparation">
                    <el-radio-group v-model="form.nature.isPreparation">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="控制信息" name="controlInfo">
              <el-row :gutter="30">
                <el-col :span="4">
                  <el-form-item label="启禁状态" prop="nature.startStopStatus">
                    <el-radio-group v-model="form.nature.startStopStatus">
                      <el-radio
                        v-for="item in WhetherStartStopOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="是否收费" prop="nature.isCharge">
                    <el-radio-group v-model="form.nature.isCharge">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="近效期提前提醒（天）"
                    prop="nature.erodByDay"
                  >
                    <el-input-number
                      v-model="form.nature.erodByDay"
                      :min="1"
                      :precision="0"
                      :controls="false"
                    >
                    </el-input-number>
                    <!-- <el-input maxlength="50" placeholder="请输入" v-model="form.nature.erodByDay" style="width:100%"></el-input> -->
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="能否入柜" prop="nature.isInCabinet">
                    <el-radio-group v-model="form.nature.isInCabinet">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="挂网信息" name="hangingNetInfo">
              <el-row :gutter="30">
                <el-col :span="4">
                  <el-form-item label="是否挂网" prop="nature.isHanging">
                    <el-radio-group v-model="form.nature.isHanging">
                      <el-radio
                        v-for="item in WhetherBooleanOptions"
                        :label="item.id"
                        :key="item.id"
                        >{{ item.name }}</el-radio
                      >
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="form.nature.isHanging">
                  <el-form-item label="挂网类型" prop="nature.hangingType">
                    <el-select
                      v-model="form.nature.hangingType"
                      value-key="id"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in hangingTypeOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="form.nature.isHanging">
                  <el-form-item
                    label="挂网药品类型"
                    prop="nature.hangingDrugsType"
                  >
                    <el-select
                      v-model="form.nature.hangingDrugsType"
                      value-key="id"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in hangingDrugsTypeOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="form.nature.isHanging">
                  <el-form-item label="挂网流水号" prop="nature.serialNumber">
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      v-model="form.nature.serialNumber"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="form.nature.isHanging">
                  <el-form-item label="挂网药品ID" prop="nature.onlineDrugID">
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      v-model="form.nature.onlineDrugID"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="form.nature.isHanging">
                  <el-form-item label="挂网单位" prop="nature.hangingUnits">
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      v-model="form.nature.hangingUnits"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4" v-if="form.nature.isHanging">
                  <el-form-item label="挂网价" prop="nature.onlinePricing">
                    <el-input-number
                      v-model="form.nature.onlinePricing"
                      maxlength="50"
                      style="width: 100%"
                      :controls="false"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="医保信息" name="healthInsuranceInfo">
              <el-row :gutter="30">
                <el-col :span="4">
                  <el-form-item
                    label="国家医保编码"
                    prop="nature.nalMedInsCode"
                  >
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      v-model="form.nature.nalMedInsCode"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="国家医保名称"
                    prop="nature.nalMedInsName"
                  >
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      v-model="form.nature.nalMedInsName"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="国家医保分类"
                    prop="nature.nalMedInsClassId"
                  >
                    <el-select
                      v-model="form.nature.nalMedInsClassId"
                      value-key="id"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in nalMedInsClassOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item
                    label="医保报销等级"
                    prop="nature.medInRebtLevel"
                  >
                    <el-select
                      v-model="form.nature.medInRebtLevel"
                      value-key="id"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="item in medInRebtLevelOption"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="省医保编码" prop="nature.proMedInsCode">
                    <el-input
                      maxlength="50"
                      placeholder="请输入"
                      v-model="form.nature.proMedInsCode"
                      style="width: 100%"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-tab-pane>
            <el-tab-pane label="产品证件" name="licenseInfo">
              <div class="registration-certificate-box">
                <span class="asterisk">*&nbsp;</span>
                <span>证照:</span>
                <el-button
                  style="margin-left: 20px"
                  class="btn primary"
                  type="primary"
                  size="small"
                  v-preventReClick
                  @click="handleRegistration"
                  >关联</el-button
                >
              </div>
              <RegistrationCertificate
                ref="registrationCertificate"
                :filterIds="ids"
                @delId="getDelId"
                :defaultId="defaultId"
                @chooseDefaultId="getChooseDefaultId"
                @certInfosData="getCertInfosData"
              />
            </el-tab-pane>
          </el-tabs>

          <ApproveInfo
            ref="approveInfo"
            v-if="showWorkFlowInfo"
            @change="approveInfoChange"
          ></ApproveInfo>
        </el-form>
      </div>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button class="btn default" v-preventReClick @click="cancel"
        >返回</el-button
      >
      <el-button class="btn default" v-preventReClick @click="submit"
        >保存</el-button
      >
    </div>
    <RegistrationCertificateModel
      v-if="open"
      :open="open"
      @dialogVisible="handleDialogVisible"
      @chooseIds="getChooseIds"
      :filterIds="ids"
    />
  </div>
</template>

<script>
import {
  GetProductUpdateById,
  SaveProductUpdate,
  RejectProductUpdate,
  GetEnumDescriptions,
  MedicationAdd,
  GetFactoryInfos,
  GetDetails,
  MedicationUpdate,
  CheckUsedState,
  SecondaryDictionaryTree,
  GetDictionarys,
  GetSystemSettings,
} from "@/api";
import { WhetherBooleanOptions, WhetherStartStopOptions } from "@/enum";
import GetDataMixin from "@/mixin/getData-mixin.js";
import MyUpload from "@/components/my-upload";
import ApproveInfo from "@/components/approve-info";
import UploadFileList from "@/components/upload-file-list";
import RegistrationCertificate from "./registration-certificate.vue";
import RegistrationCertificateModel from "./registration-certificate-model.vue";
import SelectTree from "@/components/select-tree";

export default {
  name: "manufacturerUpdateEdit",
  mixins: [GetDataMixin],
  components: {
    MyUpload,
    ApproveInfo,
    UploadFileList,
    RegistrationCertificate,
    RegistrationCertificateModel,
    SelectTree,
  },
  data() {
    return {
      WhetherBooleanOptions: WhetherBooleanOptions,
      WhetherStartStopOptions: WhetherStartStopOptions,
      reject: RejectProductUpdate,
      title: "",
      isEdit: false,
      form: {
        basicInfo: {
          no: "",
          name: "",
          commonName: "",
          pinyinCode: "",
          approvalNumber: "",
          specifications: "",
          dosageForm: "",
          doseUnit: "",
          basicdDose: "",
          drugType: "",
          classification: "",
          classificationId: "",
          classificationName: "",
          financialClass: "",
          financialClassId: "",
          financialClassName: "",
          factoryInfoName: [],
          packagingMaterial: "",
          termOfValidityByMon: 1,
          inventoryUnit: "",
          smallestUnit: "",
          inveUnitConverFactor: "",
          barcodeManagement: "",
          retrospectCode: "",
          storageMethod: "",
          isEthicals: "",
          isCautionDrug: "",
          isValuableDrug: "",
          isSichuanProduction: "",
          isControlDrug: "",
          isTestAllergy: "",
          isNewDrug: "",
          isBasicDrug: "",
          specification: "",
          accessoriesImg: null,
        },
        nature: {
          isAntibacterialDrug: "",
          antibacterialLevel: "",
          isAntibioticDrug: "",
          antibioticLevel: "",
          isPsychotropicDrug: "",
          spiritualLevel: "",
          isRadioactiveDrug: "",
          radioactiveLevel: "",
          isAnestheticDrug: "",
          isToxicDrug: "",
          isHormoneMedication: "",
          isLargeInfusionDrugs: "",
          isDigestiveDrugs: "",
          isAntitumorDrugs: "",
          isCVDrugs: "",
          isEpDrugs: "",
          isNutritionalDrugs: "",
          isPreparation: "",
          startStopStatus: true,
          isCharge: "",
          erodByDay: "",
          isInCabinet: "",
          isHanging: "",
          hangingType: "",
          hangingDrugsType: "",
          serialNumber: "",
          onlineDrugID: "",
          hangingUnits: "",
          onlinePricing: "",
          nalMedInsCode: "",
          nalMedInsName: "",
          nalMedInsClassId: "",
          medInRebtLevel: "",
          proMedInsCode: "",
        },
        certInfos: {},
      },
      rules: {
        "basicInfo.name": [
          { required: true, message: "药品名称不能为空", trigger: "blur" },
        ],
        "basicInfo.approvalNumber": [
          { required: true, message: "批准文号不能为空", trigger: "blur" },
        ],
        "basicInfo.manufacturerId": [
          { required: true, message: "生产厂商不能为空", trigger: "blur" },
        ],
        "basicInfo.specifications": [
          { required: true, message: "药品规格不能为空", trigger: "blur" },
        ],
        "basicInfo.dosageForm": [
          { required: true, message: "药品剂型不能为空", trigger: "change" },
        ],
        "basicInfo.doseUnit": [
          { required: true, message: "剂量单位不能为空", trigger: "change" },
        ],
        "basicInfo.drugType": [
          { required: true, message: "药品类型不能为空", trigger: "change" },
        ],
        "basicInfo.inventoryUnit": [
          { required: true, message: "库存单位不能为空", trigger: "blur" },
        ],
        "basicInfo.smallestUnit": [
          { required: true, message: "最小单位不能为空", trigger: "blur" },
        ],
        "basicInfo.inveUnitConverFactor": [
          { required: true, message: "单位换算系数不能为空", trigger: "blur" },
        ],
        "basicInfo.barcodeManagement": [
          { required: true, message: "条码管理不能为空", trigger: "change" },
        ],
        "basicInfo.isPrescription": [
          { required: true, message: "是否处方药品", trigger: "change" },
        ],
        "basicInfo.isHighWarning": [
          { required: true, message: "是否高警示药品", trigger: "change" },
        ],
        "basicInfo.isValuable": [
          { required: true, message: "是否贵重药品", trigger: "change" },
        ],
        "basicInfo.isInSC": [
          { required: true, message: "是否川产", trigger: "change" },
        ],
        "basicInfo.isControl": [
          { required: true, message: "是否管控药品", trigger: "change" },
        ],
        "basicInfo.isNeedSensitivity": [
          { required: true, message: "是否需要试敏", trigger: "change" },
        ],
        "basicInfo.isNewDrug": [
          { required: true, message: "是否新药", trigger: "change" },
        ],
        "basicInfo.isBasicMedicine": [
          { required: true, message: "是否基药", trigger: "change" },
        ],
        "nature.isAnestheticDrug": [
          { required: true, message: "是否麻醉药品", trigger: "change" },
        ],
        "nature.isToxicDrug": [
          { required: true, message: "是否毒性药品", trigger: "change" },
        ],
        "nature.isPsychotropicDrug": [
          { required: true, message: "是否精神类药品", trigger: "change" },
        ],
        "nature.isRadioactiveDrug": [
          { required: true, message: "是否放射性药品", trigger: "change" },
        ],
        "nature.isAntibacterialDrug": [
          { required: true, message: "是否抗菌药品", trigger: "change" },
        ],
        "nature.isAntibioticDrug": [
          { required: true, message: "是否抗生素药品", trigger: "change" },
        ],
        "nature.isHormoneMedication": [
          { required: true, message: "是否激素药品", trigger: "change" },
        ],
        "nature.isLargeInfusionDrugs": [
          { required: true, message: "是否大输液药品", trigger: "change" },
        ],
        "nature.isDigestiveDrugs": [
          { required: true, message: "是否消化药物", trigger: "change" },
        ],
        "nature.isAntitumorDrugs": [
          { required: true, message: "是否抗肿瘤药物", trigger: "change" },
        ],
        "nature.isCVDrugs": [
          { required: true, message: "是否心脑血管药物", trigger: "change" },
        ],
        "nature.isEpDrugs": [
          { required: true, message: "是否防疫药品", trigger: "change" },
        ],
        "nature.isNutritionalDrugs": [
          { required: true, message: "是否营养药物", trigger: "change" },
        ],
        "nature.isPreparation": [
          { required: true, message: "是否制剂", trigger: "change" },
        ],
        "nature.erodByDay": [
          {
            required: true,
            message: "近效期提前提醒不能为空",
            trigger: "blur",
          },
        ],
        "nature.startStopStatus": [
          { required: true, message: "请选择启停状态", trigger: "change" },
        ],
        "nature.isHanging": [
          { required: true, message: "是否挂网", trigger: "change" },
        ],
        "nature.hangingType": [
          { required: true, message: "请选择挂网类型", trigger: "change" },
        ],
        "nature.hangingDrugsType": [
          { required: true, message: "请选择挂网药品类型", trigger: "change" },
        ],
        "nature.serialNumber": [
          { required: true, message: "请输入挂网流水号", trigger: "change" },
        ],
        "nature.onlineDrugID": [
          { required: true, message: "请输入挂网药品ID", trigger: "change" },
        ],
        "nature.hangingUnits": [
          { required: true, message: "请输入挂网单位", trigger: "change" },
        ],
        "nature.onlinePricing": [
          { required: true, message: "请输入挂网价", trigger: "change" },
        ],
      },
      activeName: "basicInfo",
      editMode: false,
      smallTitleActive: 1,
      open: false,
      ids: [],
      defaultId: "",
      timer: null,
      dosageFormOption: [],
      manufacturerIdOption: [],
      doseUnitOption: [],
      drugTypeOption: [],
      classificationNameOption: [],
      inventoryUnitOption: [],
      smallestUnitOption: [],
      barcodeManagementOption: [],
      storageMethodOption: [],
      spiritualLevelOption: [],
      radioactiveLevelOption: [],
      antibacterialLevelOption: [],
      antibioticLevelOption: [],
      hangingTypeOption: [],
      hangingDrugsTypeOption: [],
      nalMedInsClassOption: [],
      medInRebtLevelOption: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      placeOfOriginOption: [],
      formMode: null,
      cascaderKey: 0, // 用于强制刷新组件
      cascaderProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          const parentId = node?.data?.id;
          const query = {
            keyWord: "",
            pageIndex: 1,
            pageSize: 1000,
            type: level,
            parentId: level === 0 ? undefined : parentId,
          };
          GetFactoryInfos(query)
            .then((res) => {
              const data = res.returnData.data || [];
              const nodes = data.map((item) => ({
                ...item,
                leaf: level >= 2, // 假设最多三级
              }));
              resolve(nodes);
            })
            .catch((error) => {
              console.error("获取级联数据失败", error);
              resolve([]);
            });
        },
        ...{
          value: "name",
          label: "name",
          emitPath: true,
          checkStrictly: true,
        },
      },
      isQuote:false,//是否引用
      disabledIsControlIsPrescriptio:false,
    };
  },
  props: {},
  watch: {
    "form.basicInfo.name": function (newVal, oldVal) {
      if (newVal) {
        this.form.basicInfo.pinyinCode = this.getInitials(newVal);
      }
    },
  },
  created() {
    this.resetForm();
    this.getFormData();
    this.getProductionRanges("");
    this.getFinanceTypes("");
    this.getProductCategory("");
    this.getManufacturers("");
  },
  methods: {
    ProductCategoryChange(node) {
      if (node) {
        this.form.basicInfo.classificationId = node.id;
        this.form.basicInfo.classificationName = node.name;
      } else {
        this.form.basicInfo.classificationId = "";
        this.form.basicInfo.classificationName = "";
      }
    },
    financeTypeChange(node) {
      if (node) {
        this.form.basicInfo.financialClassId = node.id;
        this.form.basicInfo.financialClassName = node.name;
      } else {
        this.form.basicInfo.financialClassId = "";
        this.form.basicInfo.financialClassName = "";
      }
    },
    manufacturerChange(val) {
      this.form.basicInfo.manufacturerId = val;
    },
    resetForm() {
      this.form = {
        basicInfo: {
          isPrescription: false,
          isHighWarning: false,
          isValuable: false,
          isInSC: false,
          isControl: false,
          isNeedSensitivity: false,
          isNewDrug: false,
          isBasicMedicine: false,
          barcodeManagement: null,
        },
        nature: {
          isAntibacterialDrug: false,
          isAntibioticDrug: false,
          isPsychotropicDrug: false,
          isRadioactiveDrug: false,
          isAnestheticDrug: false,
          isToxicDrug: false,
          isHormoneMedication: false,
          isLargeInfusionDrugs: false,
          isDigestiveDrugs: false,
          isAntitumorDrugs: false,
          isCVDrugs: false,
          isEpDrugs: false,
          isNutritionalDrugs: false,
          isPreparation: false,
          startStopStatus: true,
          isCharge: false,
          isInCabinet: false,
          isHanging: false,
          erodByDay: 1,
        },
        orgCode: sessionStorage.getItem("orgId"),
      };
    },
    // 获取注册证数据
    getCertInfosData(val) {
      const res = val.map((item) => {
        if (item.id == this.defaultId) {
          return {
            productRegistCertId: item.id,
            isDefault: true,
          };
        } else {
          return {
            productRegistCertId: item.id,
            isDefault: false,
          };
        }
      });
      this.form.certInfos = res;
    },
    // 保存
    submit() {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        if (this.form.basicInfo.factoryInfoName) {
          this.form.basicInfo.factoryInfoName = this.form.basicInfo
            .factoryInfoName
            ? this.form.basicInfo.factoryInfoName.join("-")
            : "";
        }
        this.form.basicInfo = {
          ...this.form.basicInfo,
        };
        if(!this.form.nature.isAntibacterialDrug){
          this.form.nature.antibacterialLevel = null
        }
        if(!this.form.nature.isAntibioticDrug){
          this.form.nature.antibioticLevel = null
        }
        if(!this.form.nature.isPsychotropicDrug){
          this.form.nature.spiritualLevel = null
        }
        if(!this.form.nature.isRadioactiveDrug){
          this.form.nature.radioactiveLevel = null
        }
        
        switch (this.formMode) {
          case 1:
            MedicationAdd(this.form).then(() => {
              this.$my_message(`新增成功`, "success");
              sessionStorage.setItem("editMode", 0);
              this.routePushWithParams(
                this.getMainPath(this.$route.path),
                this.$route.params
              );
            });
            break;
          case 2:
            this.form.basicInfo.medicationInfoId = this.form.basicInfo.id;
            CheckUsedState({
              procCatalogId: this.form.basicInfo.medicationInfoId,
            }).then((res) => {
              if (res.successful) {
                if (res.returnData) {
                  this.$my_message("业务单据被引用,系数不能修改", "warning");
                  this.isQuote = true;
                } else {
                  MedicationUpdate(this.form).then(() => {
                    this.isQuote = false;
                    this.$my_message(`修改成功`, "success");
                    sessionStorage.setItem("editMode", 0);
                    this.routePushWithParams(
                      this.getMainPath(this.$route.path),
                      this.$route.params
                    );
                  });
                }
              } else {
                this.$my_message(`校验接口失败`, "error");
              }
            });
            break;
          case 4:
            delete this.form.basicInfo.id;
            MedicationAdd(this.form).then(() => {
              this.$my_message(`新增成功`, "success");
              sessionStorage.setItem("editMode", 0);
              this.routePushWithParams(
                this.getMainPath(this.$route.path),
                this.$route.params
              );
            });
            break;

          default:
            break;
        }
      });
    },
    // 取消编辑
    cancel() {
      this.routePushWithParams(
        this.getMainPath(this.$route.path),
        this.$route.params
      );
    },
    // 上传附件
    filesChange(fileList) {
      const ids = fileList.map((item) => item.id).join(",");
      this.form.basicInfo.accessoriesImg = ids;
    },
    // 选择小标题
    chooseSmallTitle(val) {
      this.smallTitleActive = val;
      const ele = document.getElementById(`info${val}`);
      this.timer = setTimeout(() => {
        ele.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest",
        });
      }, 500);
    },
    // 点击注册证
    handleRegistration() {
      this.open = true;
    },
    // 关闭模态框
    handleDialogVisible() {
      this.open = false;
    },
    // 获取所有关联的id
    getChooseIds(val) {
      if (this.ids.length <= 0 && val.length > 0) {
        this.defaultId = val[0];
      }
      this.ids = [...this.ids, ...val];
      this.$nextTick(() => {
        this.$refs.registrationCertificate.getData();
      });
    },
    // 获取被删除的id
    getDelId(val) {
      this.ids = this.ids.filter((item) => item !== val);
      if (this.defaultId == val && this.ids.length > 0) {
        this.defaultId = this.ids[0];
      }
      this.$nextTick(() => {
        this.$refs.registrationCertificate.getData();
      });
    },
    // 获取手动选中的默认id
    getChooseDefaultId(val) {
      this.defaultId = val;
    },
    // 获取枚举数据
    async getEnum(val) {
      const query = {
        name: val,
      };
      const res = await GetEnumDescriptions(query);
      return res.returnData;
    },
    async getSecondaryDictionaryTree(type) {
      const query = {
        pageSize: 100,
        pageIndex: 1,
        type,
        sourceType: 2,
      };
      const res = await SecondaryDictionaryTree(query);
      return res?.returnData || [];
    },
    async getDictionarys(type,keyWord='') {
      const query = {
        pageSize: 10,
        pageIndex: 1,
        type,
        keyWord,
      };
      const res = await GetDictionarys(query);
      return res?.returnData.data || [];
    },
    // 获取枚举
    async initGetEnum() {
      this.drugTypeOption = await this.getEnum(
        "CASL.Model.CASLModel.Enum.Drug.DrugType"
      );
      // this.inventoryUnitOption = await this.getEnum('CASL.Model.CASLModel.Enum.Drug.InventoryUnit')
      // this.smallestUnitOption = await this.getEnum('CASL.Model.CASLModel.Enum.Drug.SmallestUnit')
      this.barcodeManagementOption = await this.getEnum(
        "CASL.Model.CASLModel.Enum.Drug.BarcodeManagement"
      );
      this.storageMethodOption = await this.getEnum(
        "CASL.Model.CASLModel.Enum.Drug.StorageMethod"
      );
      this.spiritualLevelOption = await this.getEnum(
        "CASL.Model.CASLModel.Enum.Drug.SpiritualLevel"
      );
      this.radioactiveLevelOption = await this.getEnum(
        "CASL.Model.CASLModel.Enum.Drug.RadioactiveLevel"
      );
      this.antibacterialLevelOption = await this.getEnum(
        "CASL.Model.CASLModel.Enum.Drug.AntibacterialGrade"
      );
      this.antibioticLevelOption = await this.getEnum(
        "CASL.Model.CASLModel.Enum.Drug.AntibioticLevel"
      );
      this.hangingTypeOption = await this.getEnum(
        "CASL.Model.CASLModel.Enum.Drug.HangingType"
      );
      this.hangingDrugsTypeOption = await this.getEnum(
        "CASL.Model.CASLModel.Enum.Drug.HangingDrugsType"
      );
      // this.nalMedInsClassOption = await this.getEnum('CASL.Model.CASLModel.Enum.Drug.NalMedInsClass')
      this.medInRebtLevelOption = await this.getEnum(
        "CASL.Model.CASLModel.Enum.Drug.MedInRebtLevel"
      );

      this.classificationNameOption = await this.getSecondaryDictionaryTree(1);
      this.nalMedInsClassOption = await this.getSecondaryDictionaryTree(17);
      this.dosageFormOption = await this.getDictionarys(21)
      this.doseUnitOption = await this.getDictionarys(22)
    },
    // 获取数据
    async getFormData() {
      if (this.formMode == 2 || this.formMode == 4) {
        this.isEdit = true;
        const query = {
          MedicationInfoId: this.$route.query.id,
        };
        const res = await GetDetails(query);
        if (res.returnData.basicInfo.factoryInfoName) {
          res.returnData.basicInfo.factoryInfoName =
            res.returnData.basicInfo.factoryInfoName.split("-");
            this.cascaderKey = Math.random();
        }
        this.form = res.returnData;
        if (this?.form?.certInfos.length <= 0) return;
        this.ids = this.form.certInfos.map((item) => item.productRegistCertId);
        this.defaultId = this.form.certInfos.find(
          (item) => item.isDefault === true
        )?.productRegistCertId;
        this.$nextTick(() => {
          this.$refs.registrationCertificate.getData();
        });
        const natureRes = this.form.nature
        if(natureRes.isPsychotropicDrug||natureRes.isRadioactiveDrug||natureRes.isAnestheticDrug||natureRes.isToxicDrug){
           this.disabledIsControlIsPrescriptio = true
        }else{
          this.disabledIsControlIsPrescriptio = false
        }
      } else {
        const barcodeManagement = await GetSystemSettings({
          keyWord: "InDrugBarcodeManagement",
          pageSize: 10,
          pageIndex: 1,
        });
        this.form.basicInfo.barcodeManagement =
          barcodeManagement.returnData.data[0].value == 3
            ? null
            : barcodeManagement.returnData.data[0].value;
        this.isEdit = false;
      }
      if (this.formMode == 4) {
        this.form.nature.startStopStatus = true;
        this.form.basicInfo.no = "";
      }
    },
    handleBarcodeManagement(val) {
      this.form.basicInfo.barcodeManagement = val;
    },
    async filterMethod(values,type) {
      switch (type) {
        case 'dosageForm':
          this.dosageFormOption = await this.getDictionarys(21,values)
          break;
        case 'doseUnit':
          this.doseUnitOption = await this.getDictionarys(22,values)
          break;
      
        default:
          break;
      }
    },
    async clear(type){
       switch (type) {
        case 'dosageForm':
          this.dosageFormOption = await this.getDictionarys(21)
          break;
        case 'doseUnit':
          this.doseUnitOption = await this.getDictionarys(22)
          break;
      
        default:
          break;
      }
    },
    // 选了毒麻精放这4类任何一类，是否管控药和是否处方药联动选择为‘是’，不能修改
    changeRadio(){
      const res = this.form.nature
      if(res.isPsychotropicDrug||res.isRadioactiveDrug||res.isAnestheticDrug||res.isToxicDrug){
        this.form.basicInfo.isControl = true
        this.form.basicInfo.isPrescription = true
        this.disabledIsControlIsPrescriptio = true
      }else{
        this.disabledIsControlIsPrescriptio = false
        this.form.basicInfo.isControl = false
        this.form.basicInfo.isPrescription = false
      }
    }
  },
  destroyed() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  },
  mounted() {
    this.initGetEnum();
    
  },
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  .cont-main {
    overflow: hidden;
    height: 100%;
    display: block;
    .el-form {
      overflow: hidden;
      height: 100%;
      display: flex;
      flex-direction: column;
      .demo-tabs {
        margin-top: 10px;
        flex: 1;
        height: 0;
        padding-bottom: 8px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        :deep(.el-tabs__header) {
          border: 0;
          margin-bottom: 28px;
          .el-tabs__nav {
            width: 100%;
            border: 0;
            border-bottom: 1px solid #dddddd;
          }
          .el-tabs__item {
            margin-right: 5px;
            border: 1px solid #dddddd;
            border-bottom: 0;
            background: #f8fafc;
            border-radius: 5px 5px 0 0;
            &:first-child {
              margin-left: 20px;
            }
          }
          .is-active {
            border-bottom: 1px solid #fff;
            transform: translateY(1px);
            background: transparent;
          }
        }
        :deep(.el-tabs__content) {
          // padding: 0 20px;
          overflow-y: auto;
          .el-form-item--default {
            margin-bottom: 24px;
          }
          :deep(.el-row){
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
          }
        }
      }
    }
  }
}
.oldProduction {
  width: 100%;
  max-height: 120px;
  overflow-x: hidden;

  /deep/.el-select__tags {
    max-height: 120px !important;
  }
}
.registration-certificate-box {
  margin-left: 18px;
  font-size: 14px;
  color: #606266;
  .asterisk {
    color: #ff5a5c;
    font-weight: bold;
  }
}
:deep(.el-row){
  display: flex;
  flex-wrap: wrap;
}
</style>
